import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { PositionedSpinner } from "../../components/ui/PositionedSpinner";

export const SecureApp: React.FC<any> = ({ children }) => {
  const { isAuthenticated, error, isLoading, loginWithRedirect } = useAuth0();
  useEffect(() => {
    // If the user is not authenticated, initiate login
    if (!isAuthenticated && !isLoading && !error) {
      console.log("window.location.pathname", window.location.pathname);
      loginWithRedirect({
        appState: {
          returnTo:
            window.location.pathname.indexOf("/insight") >= 0 ? window.location.pathname.replace("/insight", "") : "" // or any custom path you want to redirect to after login
        }
      });
    }
  }, [isAuthenticated, isLoading, error, loginWithRedirect]);
  if (error) {
    return `Oops, ${error}`;
  }
  if (isLoading || !isAuthenticated) {
    return <PositionedSpinner />;
  }
  return children;
};
